import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const FloppyDiskIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M13.5 1C14.3284 1 15 1.67157 15 2.5V13.5C15 14.3284 14.3284 15 13.5 15H2.5C1.67157 15 1 14.3284 1 13.5V4.62132C1 4.2235 1.15804 3.84196 1.43934 3.56066L3.56066 1.43934C3.84196 1.15804 4.2235 1 4.62132 1H5V6.5C5 6.77614 5.22386 7 5.5 7H12.5C12.7761 7 13 6.77614 13 6.5V1H13.5ZM6 11C6 12.1046 6.89543 13 8 13C9.10457 13 10 12.1046 10 11C10 9.89543 9.10457 9 8 9C6.89543 9 6 9.89543 6 11Z"
		></path>
		<path
			fill="currentColor"
			d="M8 2C8.27614 2 8.5 2.22386 8.5 2.5V5.5C8.5 5.77614 8.27614 6 8 6H7C6.72386 6 6.5 5.77614 6.5 5.5V2.5C6.5 2.22386 6.72386 2 7 2H8Z"
		></path>
	</svg>
))
